export default "__VITE_ASSET__RpT$0ftq__"